export const announcementStatuses = Object.freeze({
  Borrador: 1,
  Publicado: 2,
  Finalizado: 3,
});

export const getStatusColor = (statusId) => {
  let color = 'primary-13';
  switch (statusId) {
    case announcementStatuses.Borrador:
      color = 'gray-2';
      break;
    case announcementStatuses.Publicado:
      color = 'celadon';
      break;
    case announcementStatuses.Finalizado:
      color = 'secondary-38';
      break;
    default:
      break;
  }
  return color;
};
